import { render, staticRenderFns } from "./rk-sidebox.vue?vue&type=template&id=49700cb0&"
import script from "./rk-sidebox.vue?vue&type=script&lang=js&"
export * from "./rk-sidebox.vue?vue&type=script&lang=js&"
import style0 from "./rk-sidebox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports